(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.ba-track');
    if (!track || track.dataset.baBound) return;
    track.dataset.baBound = 'true';
    var cards = track.querySelectorAll('.ba-card');
    if (!cards.length) return;
    var prev = root.querySelector('[data-ba-prev]');
    var next = root.querySelector('[data-ba-next]');

    function step() {
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 24) || 24;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function perView() {
      return Math.max(1, Math.round(track.clientWidth / step()));
    }
    function current() {
      return Math.round(track.scrollLeft / step());
    }
    function maxIndex() {
      return Math.max(0, cards.length - perView());
    }
    function goTo(i) {
      var max = maxIndex();
      if (i > max) i = 0;   // past the last -> back to first (loop)
      if (i < 0) i = max;   // before the first -> jump to last (loop)
      track.scrollTo({ left: i * step(), behavior: 'smooth' });
    }
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });

    // Autoplay (loops too). Pauses on hover.
    var auto = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 5000;
    var timer = null;
    function start() {
      if (!auto || cards.length <= perView()) return;
      stop();
      timer = setInterval(function () { goTo(current() + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  }
  document.querySelectorAll('.ba').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.ba');
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(root) {
    if (root.dataset.bpBound) return;
    root.dataset.bpBound = 'true';
    var tabs = root.querySelectorAll('.bp-tab');
    var panels = root.querySelectorAll('.bp-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.getAttribute('data-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-panel') === i);
        });
      });
    });
  }
  document.querySelectorAll('.bp').forEach(initTabs);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.bp');
    if (r) initTabs(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["certifications"] && !Shopify.designMode) return;
  try {
    
(function () {
  function step(track) {
    var card = track.querySelector('.cf-card');
    if (!card) return 300;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 24) || 24;
    return card.getBoundingClientRect().width + gap;
  }
  function init(root) {
    var track = root.querySelector('.cf-track');
    if (!track || track.dataset.cfBound) return;
    track.dataset.cfBound = 'true';
    var prev = root.querySelector('[data-cf-prev]');
    var next = root.querySelector('[data-cf-next]');
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(track), behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(track), behavior: 'smooth' });
    });
  }
  document.querySelectorAll('.cf').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.cf');
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-black-soap"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var slider = root.querySelector('[data-hero-slider]');
    if (!slider || slider.dataset.bound) return;
    slider.dataset.bound = 'true';
    var track = slider.querySelector('.hero-track');
    var slides = slider.querySelectorAll('.hero-slide');
    if (!track || slides.length < 2) return;
    var prev = slider.querySelector('[data-hero-prev]');
    var next = slider.querySelector('[data-hero-next]');
    var dots = slider.querySelectorAll('[data-hero-dot]');

    function width() { return slides[0].getBoundingClientRect().width; }
    function current() { return Math.round(track.scrollLeft / width()); }
    function goTo(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * width(), behavior: 'smooth' });
    }
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-hero-dot'), 10)); });
    });
    function syncDots() {
      var c = current();
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === c); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); });

    var auto = slider.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(slider.getAttribute('data-interval'), 10) || 5000;
    var timer;
    function start() { if (!auto) return; stop(); timer = setInterval(function () { goTo(current() + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); }
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);
    start();
  }
  document.querySelectorAll('.hero').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.hero');
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["range-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function step(track) {
    var card = track.querySelector('.range-card');
    if (!card) return 320;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 24) || 24;
    return card.getBoundingClientRect().width + gap;
  }
  function init(root) {
    var track = root.querySelector('.range-track');
    if (!track || track.dataset.bound) return;
    track.dataset.bound = 'true';
    var prev = root.querySelector('[data-range-prev]');
    var next = root.querySelector('[data-range-next]');
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(track), behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(track), behavior: 'smooth' });
    });
  }
  document.querySelectorAll('.range').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.range');
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function step(track) {
    var card = track.querySelector('.ts-card');
    if (!card) return 320;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap || 24) || 24;
    return card.getBoundingClientRect().width + gap;
  }
  function init(root) {
    var track = root.querySelector('.ts-track');
    if (!track || track.dataset.tsBound) return;
    track.dataset.tsBound = 'true';
    var prev = root.querySelector('[data-ts-prev]');
    var next = root.querySelector('[data-ts-next]');
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(track), behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(track), behavior: 'smooth' });
    });
  }
  document.querySelectorAll('.ts').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.ts');
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
